import script from "./CreditsSliderV3.vue?vue&type=script&setup=true&lang=js"
export * from "./CreditsSliderV3.vue?vue&type=script&setup=true&lang=js"

import "./CreditsSliderV3.vue?vue&type=style&index=0&id=68fae65e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68fae65e"]])

export default __exports__